export enum EQueryKeys {
  AuthQueryKeys = 'AuthQueryKeys',
  UserBillingQueryKeys = 'UserBillingQueryKeys',
  KycQueryKeys = 'KycQueryKeys',
  TransactionKeys = 'TransactionKeys',
  WalletKeys = 'WalletKeys',
  UserKeys = 'UserKeys',
  OnOffRamp = 'OnOffRamp',
}
